/**
 * anchor effect
 */
export const sliderEffect = () => {
  $(document).on('click', '.realisations__img-slider-anchor', function(e){
    e.preventDefault();
    let imgSrc = $(this).data('img');
    $('#bigImageSlider').attr('src', imgSrc);
  })
}